<!-- Modal -->
<div class="text-484b59" id="email-camp-modal"
  style="background-color: #fff; width: 578px; border-radius: 4px;">
  <div class="text-484b59 p-4 f-20" style="background-color: #f6f6f6;">

    <!-- Modal for email-campaing Bulk Reveal -->
    <span *ngIf="calledFor === 'email-campaign'">
      <span *ngIf="totalTargets > 1">
        <span class="font-weight-600">{{totalTargets}}</span> Preferred Contact details not available
      </span>
      <span *ngIf="totalTargets == 1">
        Preferred Contact details not available
      </span>
      <!-- <i class="fa-solid fa-badge-check ml-1" style="color: #12bf08;"></i> -->
    </span>

    <!-- Modal for talentpool Bulk Reveal -->
    <span *ngIf="calledFor ==='talentpool'">
      <i class="fa-solid fa-address-book mr-1" style="color: #2E93A1;"></i> Reveal Contacts
    </span>

    <!-- Modal for All Search / Project Search / Project Pipeline Bulk Reveal (TRMS-2838) -->
    <span *ngIf="calledFor === 'listing-bulk-reveal'">
      <i class="fa-solid fa-address-book mr-1" style="color: #2E93A1;"></i> Bulk Reveal Contact
    </span>
  </div>

  <div class="m-4">
    <div class="py-4 px-3 d-flex justify-content-between"
      style="border-radius: 4px; border: solid 1px #e9ac0d; background-color: #fff8e7;">
      <span class="font-weight-500 f-16 d-flex align-items-center">
        <i class="fa-solid fa-triangle-exclamation mr-2 f-20" style="color: #e9ac0d;"></i>
        <span *ngIf="calledFor === 'email-campaign'">
          <span *ngIf="totalTargets > 1">Profiles without {{displayEmailPref}}</span>
          <span *ngIf="totalTargets == 1">Profile is without {{displayEmailPref}}</span>
        </span>
        <span *ngIf="calledFor === 'talentpool' && targetsWithoutEmail > 0">
          Profiles without Contact Information
        </span>
        <span *ngIf="calledFor === 'talentpool' && targetsWithoutEmail == 0">
          All seleted profiles have {{selectedChoiceText(talentpoolContactPrefStatus)}}
        </span>
        <span *ngIf="calledFor === 'listing-bulk-reveal' && targetsWithoutEmail > 0">
          candidate{{targetsWithoutEmail > 1 ? 's' : ''}} will be revealed
        </span>
        <span *ngIf="calledFor === 'listing-bulk-reveal' && targetsWithoutEmail == 0">
          No candidates are available for reveal
        </span>
      </span>
      <span class="f-20 font-weight-600" *ngIf="!(!(totalTargets > 1) && (calledFor === 'email-campaign')) && targetsWithoutEmail > 0">
        {{ targetsWithoutEmail}}
      </span>
    </div>


    <div *ngIf="unsubscribedCandidateCount > 0 && calledFor === 'email-campaign'" class="py-5 px-3 d-flex justify-content-between mt-4"
      style="border-radius: 4px; border: solid 1px #e54f7a; background-color: #fff5f8;">
      <span class="font-weight-500 f-16">
        <i class="fa-solid fa-triangle-exclamation mr-2 f-20" style="color: #e54f7a;"></i>
        <span>Unsubscribed profiles</span>
      </span>
      <span class="f-20 font-weight-600">
        {{ unsubscribedCandidateCount}}
      </span>
    </div>

    <!-- Choice of preference, only in talentpool -->
    <div *ngIf="calledFor === 'talentpool' ">
      <div class="f-16 font-weight-500 mt-5">Select your preferred contact information</div>
      <div>
        <mat-radio-group aria-label="Select an option" class="preference-btn d-flex flex-column pt-3" [(ngModel)]="talentpoolContactPrefStatus" (change)="preferenceSelection()">
          <mat-radio-button value="2">
            Contact Number
          </mat-radio-button>
          <mat-radio-button value="3">
            Personal Email ID
          </mat-radio-button>
          <mat-radio-button value="4">
            Professional Email ID
          </mat-radio-button>
          <!-- <mat-radio-button value="1">
            Contact Number and Personal Email ID <i class="fa-regular fa-circle-info" matTooltip="Preferrence will be given to Contact Number if we don't find both." [matTooltipClass]="{ 'red-tooltip text-black': true }"></i>
          </mat-radio-button> -->
        </mat-radio-group>
      </div>
    </div>

    <div class="mt-5">
      <div class="d-flex align-items-center" style="margin-bottom: 8px; font-size: 12px;">
          <input data-testid="auto-bulk-reveal-modal-input-1" name="candidate_level_email" type="checkbox" [(ngModel)]="candidatLevelEmail"/>
          <span for="candidate_level_email" class="mx-1">I want to receive individual contact reveal emails</span>
      </div>
      <div class="p-3 f-12" *ngIf="creditsNeeded > 0" style=" border-radius: 4px; background-color: #f6f6f6; line-height: 1.7;">
        <b>Disclaimer:</b> To Find Contacts of {{targetsWithoutEmail}} profiles, {{creditsNeeded}} Webbtree coins will be
        blocked. Unused coins will be refunded, and a usage summary will be emailed to <b>{{userEmailId}}</b> after
        completion.
      </div>
    </div>
  </div>

  <!-- When user is out of credits -->
  <div *ngIf="notEnoughCredits" class="p-3 font-weight-500" style="background-color: #fff5f8; border-radius: 4px; margin: -10px 20px 20px 20px;">
    <span style="color: #e54f7a;">
      <i class="fa-solid fa-coins mr-2"></i>
      Not enough credits
    </span>
  </div>

  <div class="d-flex justify-content-end mr-4 pb-5">
    <button data-testid="auto-bulk-reveal-modal-button-1" *ngIf="calledFor === 'email-campaign' || calledFor === 'talentpool'" class="btn-trms-white mr-2" (click)=" !isLoadingBulkReveal && closeModal('redirect')">
      <span *ngIf="calledFor === 'email-campaign'">
        Add Contacts Manually
      </span>
      <span *ngIf="calledFor === 'talentpool'">
        Add Contacts Manually
      </span>
      </button>
    <button data-testid="auto-bulk-reveal-modal-button-2" *ngIf="calledFor === 'listing-bulk-reveal'" class="btn-trms-white mr-2" (click)="!isLoadingBulkReveal && closeModal()">
      Cancel
    </button>
    <!-- <button data-testid="auto-bulk-reveal-modal-button-3" *ngIf="totalTargets > 1" class="wc-btn bg-blue py-2" -->
    <button data-testid="auto-bulk-reveal-modal-button-4" class="wc-btn bg-blue py-2"
      [ngStyle]="{'background-color': !canProcessBulk ? 'grey' : '', 'cursor': !canProcessBulk ? 'not-allowed' : 'pointer'}"
      (click)="canProcessBulk && !isLoadingBulkReveal && bulkRevelContacts()">
        <span *ngIf="!isLoadingBulkReveal">
          Find Contact
        </span>
        <span *ngIf="isLoadingBulkReveal" style="width: 100%;">
          <img style="width: 20px; margin: 0px 70px;" src="../../assets/rolling-loader-white.gif" alt="">
        </span>
    </button>

    <!-- For single candidate commented for now -->
    <!-- <button data-testid="auto-bulk-reveal-modal-button-5" *ngIf="totalTargets === 1" class="wc-btn bg-blue py-2"
      [ngStyle]="{'background-color': !canProcessBulk ? 'grey' : '', 'cursor': !canProcessBulk ? 'not-allowed' : 'pointer'}"
      (click)="canProcessBulk && !isLoadingBulkReveal && bulkRevelContacts()">
      <span *ngIf="!isLoadingBulkReveal">
        Find Contact
      </span>
      <span *ngIf="isLoadingBulkReveal" style="width: 100%;">
        <img style="width: 20px; margin: 0px 50px;" src="../../assets/rolling-loader-white.gif" alt="">
      </span>
    </button> -->
  </div>

</div>
